<template>
  <site-footer />
</template>

<script>
import SiteFooter from '@/components/home/SiteFooter.vue'

export default {
  name: 'Footer',
  components: { SiteFooter }
}
</script>
